import React from "react";
import styled from "styled-components";

import { ReactComponent as Email } from "../../../../assets/img/auth_onboarding/email.svg";
import { ReactComponent as Eye } from "../../../../assets/img/auth_onboarding/eye.svg";
import { ReactComponent as EyeSlash } from "../../../../assets/img/auth_onboarding/eye_slash.svg";
import { ReactComponent as Google } from "../../../../assets/img/auth_onboarding/google.svg";
import { ReactComponent as Add } from "../../../../assets/img/auth_onboarding/Add.svg";
import { ReactComponent as Back } from "../../../../assets/img/auth_onboarding/back.svg";
import { ReactComponent as CloseCircle } from "../../../../assets/img/auth_onboarding/close-circle.svg";
import { ReactComponent as TickCircle } from "../../../../assets/img/auth_onboarding/tick_circle.svg";
import { ReactComponent as TickCircleFilled } from "../../../../assets/img/auth_onboarding/tick_circle_filled.svg";
import { ReactComponent as InviteTeam } from "../../../../assets/img/auth_onboarding/invite_team.svg";

// Base icon styled component - much more efficient
const Icon = styled.svg`
  width: ${({ size }) => size || "24px"};
  height: ${({ size }) => size || "24px"};
  transition: all 0.2s ease;
`;

// Inline SVG Icons - No HTTP requests needed
export const EmailIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => <Icon size={size} color={color} as={Email}></Icon>;

export const EyeIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => <Icon size={size} as={Eye} {...props}></Icon>;

export const EyeSlashIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => <Icon size={size} color={color} as={EyeSlash} {...props}></Icon>;

export const GoogleIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => <Icon size={size} color={color} as={Google} {...props}></Icon>;

export const AddIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => <Icon size={size} color={color} as={Add} {...props}></Icon>;

export const BackIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => <Icon size={size} color={color} as={Back} {...props}></Icon>;

export const CloseCircleIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => <Icon size={size} color={color} as={CloseCircle} {...props}></Icon>;

export const TickCircleIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => (
  <Icon
    size={size}
    color={color}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path
      d="M9 12L11 14L15 10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const TickCircleFilledIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => (
  <Icon
    size={size}
    color={color}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="10" fill="currentColor" />
    <path
      d="M9 12L11 14L15 10"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const InviteTeamIcon = ({
  size = "24px",
  color = "currentColor",
  ...props
}) => (
  <Icon
    size={size}
    color={color}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 21V19C17 17.9 16.1 17 15 17H9C7.9 17 7 17.9 7 19V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
    <path
      d="M23 21V19C23 17.1 21.9 15.4 20.2 15.1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3.1C17.7 3.4 19 5 19 7C19 9 17.7 10.6 16 10.9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

// Export all icons
export default {
  EmailIcon,
  EyeIcon,
  EyeSlashIcon,
  GoogleIcon,
  AddIcon,
  BackIcon,
  CloseCircleIcon,
  TickCircleIcon,
  TickCircleFilledIcon,
  InviteTeamIcon,
};
